<div *ngIf="entity" class="previewCard unselectable" (click)="goToItemDetails()">

  <!-- image -->
  <div class="list-item-image" [style.background-image]="entity.mainImage ? entity.mainImage.safe : ''">

    <!-- video -->
    <!-- <iframe *ngIf="entity.videourlSafe" [src]="entity.videourlSafe" frameborder="0" allow="fullscreen" allowfullscreen style="height: 100%; width: 100%;"></iframe> -->

    <!-- triangle -->
    <div class="triangle" *ngIf="entity.category">{{ entity.category.name }}</div>

  </div>

  <!-- content -->
  <div fxLayout="column" fxLayoutGap="10px" class="content">

    <author
      [profile]="entity.profile_type===ProfileTypeIdentifier.business ? entity.frontend_user.company_profile : entity.frontend_user"
      [created_at]="entity.created_at" [lightgraymode]="true" [scrollHookListState]="entityTypeConfig.liststate">
    </author>

    <div fxFlex="grow" fxLayout="column" class="overflow-hidden" style="position: relative;">
      <div class="location">{{entity.subtitle}}</div>
      <div class="title">{{ entity.title }}</div>
      <div class="teaser">{{ entity.teaser }}</div>
      <div class="fadeout"></div>
    </div>

    <div fxFlex="noshrink" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">

      <views-display [views]="entity.count_views"></views-display>

      <contact-button [hideTextMobile]="true" [entity]="entity">
      </contact-button>

      <!-- <bookmark-button
        [bookmarked]="entity.bookmarks?.length>0"
        [entity]="entity"
        [hideTextMobile]="true"
      ></bookmark-button> -->
      <app-share-button [entity]="entity" [hideTextMobile]="true"></app-share-button>
    </div>

  </div>

</div>